/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  console.log('[Mystery Gift] Script loaded');
  var GIFT_VARIANT_ID = 57281950875913;
  var giftAddInProgress = false;
  var recheckPending = false;

  function cartHasGift(cart) {
    return cart.items.some(function (item) {
      return item.id === GIFT_VARIANT_ID;
    });
  }

  function nonGiftItemCount(cart) {
    return cart.items.reduce(function (sum, item) {
      if (item.id === GIFT_VARIANT_ID) return sum;
      return sum + item.quantity;
    }, 0);
  }

  function checkGiftState() {
    console.log('[Mystery Gift] checkGiftState called');

    if (giftAddInProgress) {
      recheckPending = true;
      return;
    }

    giftAddInProgress = true;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var hasGift = cartHasGift(cart);
        var realItemCount = nonGiftItemCount(cart);

        console.log('[Mystery Gift] realItemCount:', realItemCount, 'hasGift:', hasGift);

        if (realItemCount === 0) {
          if (hasGift) {
            var updates = {};
            updates[GIFT_VARIANT_ID] = 0;

            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function (res) { return res.json(); })
              .then(function () {
                console.log('[Mystery Gift] Removed, reloading page');
                window.location.reload();
              });
          }
          return null;
        }

        if (!hasGift) {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
            })
          }).then(function (res) { return res.json(); })
            .then(function () {
              document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
            });
        }

        return null;
      })
      .catch(function (err) {
        console.error('[Mystery Gift] Error:', err);
      })
      .finally(function () {
        giftAddInProgress = false;
        if (recheckPending) {
          recheckPending = false;
          checkGiftState();
        }
      });
  }

  document.addEventListener('theme:product:added', checkGiftState);
  document.addEventListener('theme:cart:change', checkGiftState);
  document.addEventListener('DOMContentLoaded', checkGiftState);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();